import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import { isDevelopment } from 'utils/environment';
import persistedReducer from 'redux/store/persistedReducer';

export const middleware = getDefaultMiddleware({
  serializableCheck: {
    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    ignoredActionPaths: ['payload.config', 'payload.request'],
  },
});

const store = configureStore({
  reducer: persistedReducer,
  devTools: isDevelopment,
  middleware,
});

export const persistor = persistStore(store);

export default store;
